<template>
  <NBackdrop :coverSnackbars="coverSnackbars" :fadeAway="!open" :suppressed="suppressed">
    <transition appear name="modal-animation">
      <div v-if="open" class="modal-layout" @mousedown.self="closeOnOutside && close()">
        <slot></slot>
      </div>
    </transition>
  </NBackdrop>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import NBackdrop from '@/modules/global/components/core/NBackdrop.vue'
import { ElementHistoryStore, useElementHistoryStore } from '@/modules/elements/stores/ElementHistoryStore'
import { mapStores } from 'pinia'

@Component({
  components: { NBackdrop },
  computed: {
    ...mapStores(useElementHistoryStore)
  }
})
export default class NModalBackground extends Vue {
  @Prop({ default: true, type: Boolean }) closeOnOutside!: boolean
  @Prop({ default: true, type: Boolean }) closeOnEscape!: boolean
  @Prop({ default: false, type: Boolean }) coverSnackbars!: boolean
  @Prop({ default: false, type: Boolean }) suppressed!: boolean

  open = true

  elementHistoryStore!: ElementHistoryStore

  created() {
    this.elementHistoryStore.stashActiveEntity()
  }

  mounted() {
    if (this.closeOnEscape) {
      window.addEventListener('keydown', this.onEscape)
    }
  }

  beforeDestroy() {
    this.elementHistoryStore.restoreActiveEntity()
  }

  destroyed() {
    if (this.closeOnEscape) {
      window.removeEventListener('keydown', this.onEscape)
    }
  }

  onEscape(ev: KeyboardEvent) {
    if (ev.key === 'Escape') {
      this.close()
    }
  }

  close() {
    this.open = false
    setTimeout(() => {
      this.$emit('close')
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles' as *;

.modal-layout {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  position: relative;
}

.modal-animation-leave-to /* .fade-leave-active below version 2.1.8 */ {
  transform: translateY(100vh);
}

.modal-animation-enter /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.modal-animation-enter-active {
  transition: all 100ms ease-out;
}

.modal-animation-leave-active {
  transition: all 300ms ease-out;
}

.modal-animation-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>
